const translations = new Map<string, string>();

export function setTranslations(record: Record<string, string>): void {
	translations.clear();
	for (const [key, value] of Object.entries(record)) {
		translations.set(key.toLowerCase(), value);
	}
}

export function t(key: string, interpolation?: Record<string, string>): string {
	if (typeof key !== 'string') return String(key);
	let translation = translations.get(key.toLowerCase());

	if (translation === undefined) {
		return key;
	}

	if (interpolation) {
		for (const [name, value] of Object.entries(interpolation)) {
			translation = translation.replaceAll(`{{${name}}}`, value);
		}
	}

	// [[key]] lowercases the first letter of the resolved value (mid-sentence);
	// [[Key]] preserves it (start-of-sentence).
	const BRACKET_RE = /\[\[(.+?)\]\]/g;
	for (let depth = 0; depth < 10 && BRACKET_RE.test(translation); depth++) {
		translation = translation.replace(BRACKET_RE, (_match, embeddedKey: string) => {
			const resolved = translations.get(embeddedKey.toLowerCase()) ?? embeddedKey;
			const keepCase = embeddedKey[0] === embeddedKey[0].toUpperCase();
			if (keepCase || resolved.length === 0) return resolved;
			return resolved[0].toLowerCase() + resolved.slice(1);
		});
	}

	return translation;
}
